/* POA / CART — single owner of all cart behaviour.

   Drawer open/close, add, quantity, remove and PDP variant selection all live
   here. poa.js deliberately contains no cart code: when both files handled the
   cart, add-to-cart read the FIRST radio rather than the CHECKED one and every
   order came through as size S.

   Adds always go through FormData(form), which serialises the checked radio
   correctly. Never hand-pick the variant input.

   Line updates use Shopify's Cart AJAX API, and the drawer is re-rendered from
   the Section Rendering API so prices, discounts and totals are whatever
   Shopify says they are — never recomputed in the browser. */
(function () {
  var SECTION = 'cart-drawer';
  var busy = false;

  function drawer()  { return document.getElementById('cart-drawer'); }
  function scrim()   { return document.getElementById('cart-scrim'); }
  function bodyEl()  { return document.getElementById('cartBody'); }
  function totalEl() { return document.getElementById('cartTotal'); }

  function setBusy(state) {
    busy = state;
    var d = drawer();
    if (!d) return;
    d.setAttribute('aria-busy', state ? 'true' : 'false');
    d.classList.toggle('is-loading', !!state);
  }

  function openCart() {
    var d = drawer(), s = scrim();
    if (!d) return;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    if (s) s.classList.add('visible');
  }

  function closeCart() {
    var d = drawer(), s = scrim();
    if (!d) return;
    d.classList.remove('open');
    d.setAttribute('aria-hidden', 'true');
    if (s) s.classList.remove('visible');
  }

  /* Re-render the drawer's inner parts from freshly evaluated Liquid. The
     #cart-drawer element itself is never replaced, so listeners stay bound. */
  function refresh() {
    return fetch('/?sections=' + SECTION, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var freshBody = doc.getElementById('cartBody');
        var curBody = bodyEl();
        if (freshBody && curBody) curBody.innerHTML = freshBody.innerHTML;

        var freshTotal = doc.getElementById('cartTotal');
        var curTotal = totalEl();
        if (freshTotal && curTotal) curTotal.textContent = freshTotal.textContent;

        var freshBtn = doc.querySelector('.foot .checkout');
        var curBtn = document.querySelector('#cart-drawer .foot .checkout');
        if (freshBtn && curBtn) {
          if (freshBtn.hasAttribute('disabled')) curBtn.setAttribute('disabled', '');
          else curBtn.removeAttribute('disabled');
        }
      })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var counts = document.querySelectorAll('#cartCount');
        for (var i = 0; i < counts.length; i++) counts[i].textContent = cart.item_count;
      })
      .catch(function (err) { console.warn('POA cart refresh:', err); });
  }

  /* quantity 0 removes the line — documented Cart API behaviour, so remove and
     "step down from 1" share one path. */
  function change(key, quantity) {
    if (busy) return Promise.resolve();
    setBusy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || r.statusText); });
        return r.json();
      })
      .then(function () { return refresh(); })
      .catch(function (err) { console.warn('POA cart change:', err); })
      .finally(function () { setBusy(false); });
  }

  /* ---- delegated events: survive every drawer re-render ---- */

  document.addEventListener('click', function (e) {
    if (e.target.closest('#cartOpen')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('#cartClose') || e.target.closest('#cart-scrim')) { e.preventDefault(); closeCart(); return; }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      change(removeBtn.getAttribute('data-key'), 0);
      return;
    }

    var stepBtn = e.target.closest('[data-cart-step]');
    if (stepBtn) {
      e.preventDefault();
      var line = stepBtn.closest('[data-cart-line]');
      var numEl = line ? line.querySelector('[data-cart-qty]') : null;
      var current = numEl ? parseInt(numEl.textContent.trim(), 10) : NaN;
      if (isNaN(current)) return;
      var next = current + parseInt(stepBtn.getAttribute('data-cart-step'), 10);
      if (next < 0) next = 0;
      change(stepBtn.getAttribute('data-key'), next);
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (e.key === 'Escape' && d && d.classList.contains('open')) closeCart();
  });

  /* ---- PDP variant selection ---- */
  /* The radio is the source of truth for the form. This handler only keeps the
     visible price, button label and active state in sync with it. */
  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (!radio.matches || !radio.matches('input[name="id"]')) return;

    var label = radio.closest('.sz');
    var form = radio.closest('form');
    if (!form) return;

    form.querySelectorAll('.sz').forEach(function (s) { s.classList.remove('active'); });
    if (label) label.classList.add('active');

    var price = label && label.getAttribute('data-price');
    var available = label && label.getAttribute('data-available') === 'true';

    var priceEl = form.querySelector('[data-price-target]');
    if (priceEl && price) priceEl.textContent = price;

    var btn = form.querySelector('[data-add-btn]');
    if (btn) {
      if (available) {
        btn.removeAttribute('disabled');
        btn.textContent = 'Add to cart — ' + (price || '');
      } else {
        btn.setAttribute('disabled', 'true');
        btn.textContent = 'Sold out';
      }
    }
  });

  /* ---- add to cart ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;

    e.preventDefault();

    // FormData picks up the CHECKED radio. Do not querySelector the input.
    var fd = new FormData(form);
    if (!fd.get('id')) {
      console.warn('POA cart add: no variant selected');
      return;
    }

    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('disabled', 'true'); btn.textContent = 'ADDING…'; }

    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || 'Add to cart failed'); });
        return r.json();
      })
      .then(function () { return refresh(); })
      .then(function () { openCart(); })
      .catch(function (err) {
        console.warn('POA cart add:', err);
        form.submit(); // hard fallback — never strand the customer
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('disabled'); btn.textContent = original; }
      });
  });
})();
